import { render, staticRenderFns } from "./private.vue?vue&type=template&id=4be31f5d&scoped=true&"
var script = {}
import style0 from "./private.vue?vue&type=style&index=0&id=4be31f5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be31f5d",
  null
  
)

export default component.exports